var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{
    name: 'LeadersDraft',
    params: { draft_id: _vm.entity.id },
    query: { tab: 'search', id: _vm.draw.rider.user_id, select: 'competitor' }
  }}},[_vm._v("\n  "+_vm._s(_vm.draw.rider.name)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d2c55c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Leaders/Listing/components/Links/LinkRider.vue
// module id = 1033
// module chunks = 30